import React from "react";
import Style from "../../styles/js/StyleUtils";
import TextField from "@material-ui/core/TextField";
import { ColorButton } from "../../components/common/CustomButton.js";

export default function SelectDates({
  initialDate,
  finalDate,
  handleChange,
  submit,
}) {
  const style = Style();

  return (
    <div className={style.selectDates}>
      <TextField
        id="datetime-local"
        label="Fecha de inicio"
        type="datetime-local"
        name="initialDate"
        value={initialDate}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        id="datetime-local"
        label="Fecha de fin"
        type="datetime-local"
        name="finalDate"
        value={finalDate}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <ColorButton onClick={submit} style={{ width: "150px" }}>
        BUSCAR
      </ColorButton>
    </div>
  );
}
